"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = void 0;
var actions = require("../../../actions/navigation");
var CurrentActions = require("@caddigital/sok-reducers/lib/actions/auth/current");
var LoginActions = require("@caddigital/sok-reducers/lib/actions/auth/login");
var ZendeskActions = require("@caddigital/sok-reducers/lib/actions/auth/zendesk");
var cartActions = require("@caddigital/sok-reducers/lib/actions/cart");
var cart_1 = require("@caddigital/sok-reducers/lib/actions/cart");
var translations_1 = require("@caddigital/sok-reducers/lib/actions/translations");
var userSettings_1 = require("@caddigital/sok-reducers/lib/actions/user/userSettings");
var translate_1 = require("utils/translate");
var mapDispatchToProps = function (dispatch) { return ({
    toggleNavigationMenu: function () { return dispatch(actions.toggleNavigationMenu()); },
    toggleNavigationMenuWidth: function () {
        return dispatch(actions.toggleNavigationMenuWidth());
    },
    toggleCart: function () {
        dispatch((0, cart_1.toggleCart)());
    },
    logout: function () { return dispatch(LoginActions.logout()); },
    zendeskToken: function () { return dispatch(ZendeskActions.createZendeskTokenRequest()); },
    clearToken: function () { return dispatch(ZendeskActions.resetZendeskToken()); },
    openUserSettingsModal: function (user) {
        return dispatch((0, userSettings_1.openUserSettingsModal)(user, 'USER', [
            CurrentActions.getUserinfoRequestAction()
        ]));
    },
    updateUserLanguage: function (lang) {
        (0, translate_1.setLanguage)(lang);
        dispatch((0, translations_1.fetchLanguageRequest)(lang));
        dispatch(CurrentActions.updateUserLanguage(lang));
    },
    onRemoveItemFormCart: function (rootId) { return function (ids) {
        dispatch(cartActions.removeItems(ids, rootId));
    }; },
    showCartInfoText: function (isInfoVisible) {
        return dispatch(cartActions.showCartInfo(isInfoVisible));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
